/* HH "Set & Forget" buy box v9 (Cowork, Sep 2026)
   1) box count (+ bonus-pack size picker)  2) sizes  3) Set & Forget / One-time
   + sticky ATC bar, paid add-on, cart-drawer open on add, "+18%" bubble on the hero bar,
     Dawn variant picker hidden, $0 bonus-pack lines (first order only).
   v9: Crew Rewards perk line (every 30 boxes = 1 free box, /pages/crew).
   v10 (7 Sep 2026): prepay option removed — plans deleted in Appstle.
   v11 (7 Sep 2026): perks trimmed (no Welcome Kit, guarantee perk, Crew Rewards = members
   only); frequency select gets a chevron + "you choose" hint; sticky bar is now
   image + box-count select + price + ATC (no mode/frequency text).

   FREQUENCY: plans are sorted by delivery interval ascending and the DEFAULT is
   whichever plan Appstle names "(recommended)". Add/rename plans in Appstle and this
   follows automatically. Repeat-purchase analysis (145 customers, 6 Sep) put the
   median reorder gap at 56 days, so 8 weeks is the recommended default; 30% of gaps
   exceed 12 weeks, hence the 16 and 26 week options.

   RENEWAL REASSURANCE: Shopify's checkout prints a "Recurring subtotal" that excludes
   discounts (its own fine print says so) and it cannot be edited without Shopify Plus.
   So we state the true renewal price here and in the cart, BEFORE checkout, and the
   customer reads the checkout figure as pre-discount rather than as a nasty surprise.

   Cart adds go through the page's own window.fetch (25 Oct 2026 pixel audit - see addToCart).
   They used to go through a hidden iframe, which no app pixel could see.

   PRICING RULE (matches live carts to the cent):
     unit = round(RRP * (1 - sellingPlanPct/100))   <- Shopify ROUNDS the plan adjustment
     perBox = unit - floor(unit * tierPct/100)      <- Shopify FLOORS the discount amount

   25 OCT 2026 (owner's CRO brief, Grip-X add-to-cart 5.9% -> 7.5%):
   - Add to cart is never disabled. With no boxes chosen it scrolls to "2 · Pick your
     size", shakes the chips and says "Pick a size first" (nudgeSize).
   - The button always says what will happen: "Add 10 boxes · $216.90", same on the
     sticky bar. Prices are the same perBox() maths as before, so they still match the cart.
   - Default size is L (90-day Grip-X boxes: L 2,321 · XL 1,523 · M 500 · XXL 29).
   - Picking a bundle keeps the sizes already chosen (scaled), instead of resetting to M.
   - Sizes: four big chips (one tap = the whole bundle in that size); "Mix sizes" shows
     48px steppers. A line under them names the price that applies ("12 boxes · CREW price").
   - Sticky bar shows only once the real button is off screen and never sits on top of
     the bundle tiles or the size chips.
   - "Size guide" opens /pages/find-your-glove-size in a bottom sheet (no page change).
   - Customer Events: tile_selected, size_selected, atc_clicked, atc_blocked_no_size,
     size_guide_opened, sticky_atc_used (Shopify.analytics.publish).

   25 OCT 2026 - BLACK NOVEMBER MODE (owner brief, 24 Oct) and "Only need one box?":
   - While html.hh-bn is set (layout/theme.liquid sets it before first paint, from the
     Black November theme settings or ?bn=1) the tiles come from window.HH_BN_TILES
     (snippets/hh-bn-tiles.liquid -> snippets/hh-bn-cfg.liquid): three tiles SOLO / CREW /
     FLEET, CREW pre-selected, one-time only - no Set & Forget, no selling plan, no bonus
     packs or freshener property from here (assets/hh-gift-guard.js adds the Black November
     gifts in the cart). The same engine runs on all seven glove pages that way.
   - 1-3 boxes still buy at the SOLO rate (basePct), with no tile of their own.
   - Outside Black November nothing changes: Grip-X uses HH_TIERS, and on the other gloves
     there is no HH_TIERS, so this script exits and Shopify's own buy box stays.
   - A quiet "Only need one box?" text button under the tiles (both modes): 1 box in the
     size already picked (else L), one-time, steppers open. Event: single_box_selected.

   25 OCT 2026 (owner's review, second pass):
   - Everyday tiles lose the "SAVE xx%" pill. Rule of 100: under $100 a percentage reads
     bigger, over $100 a dollar amount does, and every bundle total is over $100, so the
     "Save $X" line stays and the percentage goes. (The Black November tiles lead with a
     per-box price, which is under $100, so they keep their SAVE %.)
   - Set & Forget perks: Priority Member Shipping and Crew Rewards are gone; the guarantee
     perk is 60-day (first Set & Forget order, per the refund policy).
   - The sticky bar is always on screen unless the real Add to cart is in view.
   - "Size guide" opens a short finder (snippets/hh-size-guide.liquid): the bank-card slider,
     the size, and how it should feel. Products without published palm widths hide the link. */
(function () {
  var BNT = window.HH_BN_TILES;
  var BN = !!(BNT && BNT.cfg && BNT.cfg.tiers && BNT.cfg.tiers.length && document.documentElement.classList.contains('hh-bn'));
  var D = BN ? {
    bn: true,
    productId: BNT.productId,
    rrp: BNT.rrp,
    shipMin: BNT.shipMin || 14900,
    blueRrp: BNT.blueRrp || 0,
    defaultQty: 10,
    basePct: BNT.cfg.tiers[0].pct,
    labels: {},
    variants: BNT.variants || [],
    plans: [],
    gifts: {},
    tiers: BNT.cfg.tiers.map(function (x) {
      return { q: x.q, pct: x.pct, sub: x.note, ribbon: x.name, badge: x.badge, label: x.label, gifts: x.gifts || [], gift: '', incl: '' };
    })
  } : window.HH_TIERS;
  if (!D || !D.variants || !D.variants.length) return;
  var root = document.querySelector('[data-hh-tiers]');
  if (!root) return;

  if (window.HH_PDP_BAR && D.tiers && !D.bn) {
    window.HH_PDP_BAR.tiers = D.tiers.map(function (t) {
      return { q: t.q, p: Math.round(t.pct), bonus: t.q === 4 ? 'ship' : 'gift' };
    });
  }

  /* 25 Oct 2026 (pixel audit): adds go through the page's own window.fetch, because that is
     the only add Shopify's pixel manager can see - and it is what sends Meta AddToCart, GA4
     add_to_cart, TikTok AddToCart and Shopify's own add-to-cart count. From 7 Sep the buy box
     added through a hidden iframe instead; measured on the live theme, its adds reached
     Shopify's count (via hh-cart-analytics.js) but never reached a single app pixel.
     The iframe existed because Appstle and Fly stripped selling_plan from window.fetch adds.
     With Fly switched off the plan survives (verified 25 Oct), and if anything ever strips it
     again, fixPlan() puts it back through an untouched fetch - so a Set & Forget add can never
     quietly become a one-time order. That untouched fetch is made only if it is needed. */
  var cleanF = null;
  function cleanFetch() {
    if (cleanF) return cleanF;
    try {
      var f = document.createElement('iframe');
      f.style.display = 'none';
      (document.body || document.documentElement).appendChild(f);
      var ff = f.contentWindow && f.contentWindow.fetch;
      if (ff) { cleanF = ff.bind(f.contentWindow); return cleanF; }
    } catch (e) {}
    cleanF = window.fetch.bind(window);
    return cleanF;
  }
  var ORIGIN = window.location.origin;

  function weeks(p) {
    var n = Number(p.every) || 0, u = String(p.unit || 'week').toLowerCase();
    if (u.indexOf('month') === 0) return n * 4.345;
    if (u.indexOf('year') === 0) return n * 52;
    if (u.indexOf('day') === 0) return n / 7;
    return n;
  }
  var payg = D.plans.slice().sort(function (a, b) { return weeks(a) - weeks(b); });
  var recommended = payg.filter(function (p) { return /recommend/i.test(p.name); })[0] || payg[0];
  var subPct = recommended ? Number(recommended.pct) : 0;
  var LABEL = D.labels || {};
  var SUB_TITLE = LABEL.sub || 'Set &amp; Forget';
  var GIFTS = [];
  if (D.gifts) { Object.keys(D.gifts).forEach(function (k) { if (D.gifts[k]) GIFTS.push(D.gifts[k]); }); }

  function cleanName(p) {
    return String(p.name).replace(/\s*[—–-]\s*Save\s*[\d.]+%\s*/i, ' ').replace(/\s+/g, ' ').trim();
  }
  function everyTxt(p) {
    var w = Math.round(weeks(p));
    return w ? ('every ' + w + ' week' + (w === 1 ? '' : 's')) : 'each delivery';
  }

  var state = { mode: payg.length ? 'sub' : 'one', planId: recommended ? recommended.id : null, alloc: {}, addon: null, giftSize: {} };

  function money(c) { return '$' + (c / 100).toFixed(2); }
  function money0(c) { return '$' + Math.round(c / 100); }
  function boxesTxt(n) { return n + ' box' + (n === 1 ? '' : 'es'); }
  /* Custom Customer Events on the Web Pixels bus. A custom pixel (Settings > Customer
     events) subscribes to them. Can never throw into the buy box. */
  function track(name, data) {
    try { if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') Shopify.analytics.publish(name, data || {}); } catch (e) {}
  }
  function tierName(t) { return t && t.ribbon ? String(t.ribbon).toUpperCase() : (t && t.q ? t.q + '-BOX' : ''); }
  function chosenSizes() { return Object.keys(state.alloc).filter(function (k) { return state.alloc[k] > 0; }); }
  function sizeTitle(vid) { var v = D.variants.filter(function (x) { return String(x.id) === String(vid); })[0]; return v ? v.title : ''; }
  /* Default size L - the owner's call, 25 Oct 2026. Falls back to the first size in stock. */
  function defaultVid() {
    var avail = D.variants.filter(function (v) { return v.available; });
    if (!avail.length) return null;
    var l = avail.filter(function (v) { return /^\s*l\s*$/i.test(String(v.title)); })[0];
    return String((l || avail[0]).id);
  }
  var mixOpen = false;
  var stickyQueue = null;

  /* A tier earns a bonus PACK when it clears a GIFTS minQ - that is 10 (SE Premium
     Black) and 20 (Black + Blue). The 6-box AIR FRESHENER is NOT one of these: the
     owner keeps the freshener on every order, one-time included (2 Oct 2026), and
     only the packs are a Set & Forget perk. */
  function earnsPack(q) {
    return GIFTS.some(function (g) { return g && g.variants && g.variants.length && q >= g.minQ; });
  }
  function tierFor(q) {
    var best = null;
    D.tiers.forEach(function (x) { if (q >= x.q) best = x; });
    /* under the first bundle: everyday = full price; Black November = the SOLO rate */
    return best || { q: 0, pct: D.basePct || 0, gift: '', incl: '' };
  }
  function planPctFor(mode, pid) {
    if (mode === 'one') return 0;
    var p = D.plans.filter(function (x) { return String(x.id) === String(pid || state.planId); })[0];
    return p ? Number(p.pct) : subPct;
  }
  function perBox(q, mode, pid) {
    var unit = Math.round(D.rrp * (1 - planPctFor(mode, pid) / 100));
    var pct = tierFor(q).pct;
    if (!pct) return unit;
    return unit - Math.floor(unit * pct / 100);
  }
  function totalQty() { return Object.keys(state.alloc).reduce(function (a, k) { return a + (state.alloc[k] || 0); }, 0); }
  function grandTotal() {
    var q = totalQty();
    var t = perBox(q, state.mode) * q;
    if (state.addon) t += state.addon.price;
    return t;
  }
  function currentPlan() {
    return D.plans.filter(function (x) { return String(x.id) === String(state.planId); })[0];
  }
  function dominantSize() {
    var best = null, n = -1;
    Object.keys(state.alloc).forEach(function (k) {
      if ((state.alloc[k] || 0) > n) { n = state.alloc[k]; best = k; }
    });
    var v = D.variants.filter(function (x) { return String(x.id) === String(best); })[0];
    return v ? v.title : null;
  }

  /* Black November tiles (owner's layout, 24 Oct 2026): name, boxes, per-box price as the
     biggest number with the one-box price struck beside it, ONE "SAVE xx%" (1 - multiplier),
     then the label, the shipping line and any gift lines. No totals and no "Save $X".
     "Free shipping" only when the tile's own total clears the threshold, else "+ shipping":
     a CREW carton of SE Premium is $70.20, so a blanket free-shipping line would be false. */
  function renderTiersBN() {
    var active = tierFor(totalQty()).q;
    var list = root.querySelector('[data-hh-tierlist]');
    list.classList.add('hh-bn-list');
    /* 4 Nov 2026 (owner): Black November tiles are the same size as the everyday ones - same
       markup and classes (name pill, boxes, saving, deal line, price per box last). Shipping and
       gifts for the SELECTED tile sit on one line under the tiles ([data-hh-bnperks]). */
    list.innerHTML = D.tiers.map(function (t) {
      var pb = perBox(t.q, 'one');
      return '<button type="button" class="hh-t-card' + (active === t.q ? ' is-on' : '') + '" data-q="' + t.q + '" aria-pressed="' + (active === t.q ? 'true' : 'false') + '">' +
        '<span class="hh-t-rib">' + t.ribbon + '</span>' +
        (t.label
          ? '<span class="hh-t-qty hh-bn-deal">' + t.label.replace(/^\s*buy\s+(\d+),?\s+get\s+(\d+)\s+free\s*$/i, '$1 + $2 FREE') + '</span>'   /* "8 + 2 FREE" (owner, 4 Nov 2026) */
          : '<span class="hh-t-qty">' + t.q + ' Boxes</span>') +
        '<span class="hh-t-saved">Save ' + t.pct + '%</span>' +
        '<span class="hh-t-gift">' + ((t.gifts || []).length ? '+ ' + t.gifts.length + ' Free Gift' + (t.gifts.length > 1 ? 's' : '') : '') + '</span>' +
        '<span class="hh-t-pb">' + money(pb) + '<i>per box</i></span>' +
      '</button>';
    }).join('');
    var on = D.tiers.filter(function (t) { return t.q === active; })[0] || D.tiers[0];
    var perks = root.querySelector('[data-hh-bnperks]');
    if (!perks) {
      perks = document.createElement('p');
      perks.className = 'hh-bn-perks';
      perks.setAttribute('data-hh-bnperks', '');
      list.insertAdjacentElement('afterend', perks);
    }
    /* one line: shipping + the selected tile's gifts; the SE Premium Blue box gets a size picker
       (saved to localStorage hh_bn_blue_size, which assets/hh-gift-guard.js uses when it adds it) */
    var free = perBox(on.q, 'one') * on.q >= D.shipMin;
    var parts = [free ? 'Free shipping' : 'Free shipping from ' + money(D.shipMin).replace(/\.00$/, '')], blue = false;
    (on.gifts || []).forEach(function (g) {
      if (/premium blue/i.test(g)) blue = true;
      parts.push(g.replace(/^\+\s*/, '').replace(/\s*\(pick your size\)/i, '').replace(/^FREE (box of )?/i, ''));
    });
    var bsz = '';
    if (blue) {
      try { bsz = localStorage.getItem('hh_bn_blue_size') || ''; } catch (e) {}
      if (!/^(S|M|L|XL)$/.test(bsz)) {
        var vid = chosenSizes()[0], vv = D.variants.filter(function (v) { return String(v.id) === String(vid); })[0];
        var top = vv ? String(vv.title).toUpperCase() : '';
        bsz = /^(S|M|L|XL)$/.test(top) ? top : 'L';
      }
    }
    /* the free SE Premium Blue box (owner, 4 Nov 2026): ONE line - name, its normal price struck
       through, FREE, and a size picker with the site's dropdown arrow */
    if (blue) parts = parts.filter(function (p) { return !/SE Premium Blue/i.test(p); });   /* it has its own row below */
    var ptxt = '<span>' + (parts.length > 2 ? parts[0] + ', ' + parts.slice(1).join(' + ') : parts.join(' + ')) + '</span>' + (blue
      ? '<label class="hh-bn-giftrow">SE Premium Blue ' + (D.blueRrp ? '<s>' + money(D.blueRrp) + '</s> ' : '') + '<b class="hh-bn-free">FREE</b>' +
        '<span class="hh-t-freqwrap"><select data-hh-bnblue aria-label="Size of your free SE Premium Blue box">' +
          ['S', 'M', 'L', 'XL'].map(function (s) { return '<option' + (s === bsz ? ' selected' : '') + '>' + s + '</option>'; }).join('') +
        '</select></span></label>' : '');
    if (perks.innerHTML !== ptxt) perks.innerHTML = ptxt;
    if (blue && !perks.__hhBound) {
      perks.__hhBound = true;
      perks.addEventListener('change', function (e) {
        if (!e.target.matches('[data-hh-bnblue]')) return;
        try { localStorage.setItem('hh_bn_blue_size', e.target.value); } catch (x) {}
      });
    }
    var incl = root.querySelector('[data-hh-incl]');
    if (incl) { incl.innerHTML = ''; incl.hidden = true; }
  }

  function renderTiers() {
    if (D.bn) { renderTiersBN(); return; }
    var active = tierFor(totalQty()).q;
    root.querySelector('[data-hh-tierlist]').innerHTML = D.tiers.map(function (t) {
      var pb = perBox(t.q, state.mode, state.planId);
      var saved = (D.rrp - pb) * t.q;
      return '<button type="button" class="hh-t-card' + (active === t.q ? ' is-on' : '') + '" data-q="' + t.q + '">' +
        /* owner's order (25 Oct 2026): name, boxes, the saving, the gift, price per box last */
        (t.ribbon ? '<span class="hh-t-rib">' + t.ribbon + '</span>' : '') +
        '<span class="hh-t-qty">' + t.q + ' Boxes</span>' +
        '<span class="hh-t-note">' + (t.sub || '&nbsp;') + '</span>' +
        '<span class="hh-t-saved">Save ' + money0(saved) + '</span>' +
        '<span class="hh-t-gift">' + (state.mode === 'one' && earnsPack(t.q) ? '' : t.gift) + '</span>' +
        '<span class="hh-t-pb">' + money(pb) + '<i>per box</i></span>' +
      '</button>';
    }).join('');
    var t = tierFor(totalQty());
    var incl = root.querySelector('[data-hh-incl]');
    /* Free packs are a Set & Forget perk, so a One-time shopper must not be shown
       "+1 free pack" on the card or "includes a free pack" underneath it. The cart
       has to match the promise - see the GIFTS guard in addToCart. */
    var inclTxt = (state.mode === 'one' && earnsPack(t.q)) ? '' : t.incl;
    incl.innerHTML = inclTxt ? '<span class="hh-t-inclico"></span>' + inclTxt : '';
    incl.hidden = !inclTxt;
  }

  function renderGiftPick() {
    /* 1 Oct 2026: the free packs now render INSIDE the Set & Forget panel instead of
       under the bundle grid. Two reasons: the owner wanted them in that box, which
       had empty space, and they are a subscription perk so they belong beside the
       other subscription benefits.

       renderAll() calls this AFTER renderBuy() for that reason - renderBuy replaces
       the entire [data-hh-buylist] subtree, so anything written into the panel
       before it ran would be wiped. The original [data-hh-gift] host in step 1 is
       left in the markup and simply emptied, so the section file did not have to
       change. */
    var legacy = root.querySelector('[data-hh-gift]');
    if (legacy) { legacy.hidden = true; legacy.innerHTML = ''; }
    /* IDEMPOTENT. This no longer overwrites a host's innerHTML, it INSERTS an
       element, and the [data-gsz] size buttons call renderGiftPick() on its own
       without a full renderAll() - so without this removal every size tap would
       leave another copy of the block behind. */
    var old = root.querySelector('[data-hh-buylist] .hh-t-gp--panel');
    if (old && old.parentNode) old.parentNode.removeChild(old);
    /* RENDERS IN ONE-TIME MODE TOO (owner, 2 Oct 2026). It used to bail out when the
       shopper was on One-time, so the free-pack rows vanished the moment they switched.
       The owner wants them left on show at 10 and 20 boxes - greyed and crossed out by
       assets/hh-buybox-steps.css - as the reason to go back to Set & Forget.

       DISPLAY ONLY. What actually goes in the cart is unchanged: addToCart() still has
       its own `if (state.mode === 'one') return;` inside the GIFTS loop, so a one-time
       order never carries a bonus-pack line. The promise and the cart still match. */
    var panel = root.querySelector('[data-hh-buylist] .hh-t-panel');
    if (!panel) return;
    var tot = totalQty();
    var open = GIFTS.filter(function (g) { return g && g.variants && g.variants.length && tot >= g.minQ; });
    if (!open.length) return;
    var dom = dominantSize();
    var wrap = document.createElement('div');
    wrap.className = 'hh-t-gp hh-t-gp--panel';
    panel.insertBefore(wrap, panel.firstChild);
    wrap.innerHTML = open.map(function (g) {
      if (!state.giftSize[g.key]) {
        var match = g.variants.filter(function (v) { return v.title === dom; })[0];
        state.giftSize[g.key] = String((match || g.variants[0]).id);
      }
      return '<div class="hh-t-gprow">' +
        '<img src="' + (g.img || '') + '" alt="" loading="lazy">' +
        '<span class="hh-t-gpinfo"><b>🎁 Free pack — ' + g.short + '</b>' +
          '<span class="hh-t-gpfree">FREE' + (g.worth ? ' — normally ' + money(g.worth) : '') + ' · pick a size</span></span>' +
        '<span class="hh-t-gpsizes">' + g.variants.map(function (v) {
          return '<button type="button" class="hh-t-gpsz' + (String(state.giftSize[g.key]) === String(v.id) ? ' is-on' : '') + '" data-gift="' + g.key + '" data-gsz="' + v.id + '">' + v.title + '</button>';
        }).join('') + '</span>' +
      '</div>';
    }).join('');
  }

  function renderSizes() {
    var sizesEl = root.querySelector('[data-hh-sizes]');
    sizesEl.innerHTML = D.variants.filter(function (v) { return v.available; }).map(function (v) {
      var n = state.alloc[v.id] || 0;
      return '<div class="hh-t-size' + (n > 0 ? ' has' : '') + '" data-sz="' + v.id + '" role="button" tabindex="0" aria-pressed="' + (n > 0 ? 'true' : 'false') + '" aria-label="' + v.title + (n > 0 ? ', ' + boxesTxt(n) : '') + '">' +
        '<span class="hh-t-sizename">' + v.title + '</span>' +
        '<span class="hh-t-sizeqty">' + (n > 0 ? boxesTxt(n) : '&nbsp;') + '</span>' +
        '<span class="hh-t-step2">' +
        '<button type="button" class="hh-t-mi" data-v="' + v.id + '" data-d="-1" aria-label="One less ' + v.title + '">&minus;</button>' +
        '<input class="hh-t-num" type="number" min="0" inputmode="numeric" value="' + n + '" data-v="' + v.id + '" aria-label="' + v.title + ' boxes">' +
        '<button type="button" class="hh-t-mi" data-v="' + v.id + '" data-d="1" aria-label="One more ' + v.title + '">+</button>' +
        '</span></div>';
    }).join('');
    sizesEl.classList.toggle('is-mix', mixOpen);
    var mixBtn = root.querySelector('[data-hh-mix]');
    if (mixBtn) { mixBtn.setAttribute('aria-expanded', mixOpen ? 'true' : 'false'); mixBtn.textContent = mixOpen ? 'Hide mix' : 'Mix sizes'; }
    if (totalQty() > 0) {
      sizesEl.classList.remove('hh-shake');
      var smsg = root.querySelector('[data-hh-sizemsg]'); if (smsg) smsg.hidden = true;
    }
    renderRate();
    var tot = totalQty();
    var next = D.tiers.filter(function (x) { return x.q > tot; })[0];
    root.querySelector('[data-hh-count]').innerHTML =
      '<span><b>' + tot + '</b> box' + (tot === 1 ? '' : 'es') + ' &middot; ' + money(perBox(tot, state.mode)) + '/box</span>' +
      (next ? '<span class="hh-t-next">Add ' + (next.q - tot) + ' more &rarr; ' + money(perBox(next.q, state.mode)) + '/box</span>' : '<span></span>');
  }

  /* "12 boxes · CREW price" - shown when the sizes are mixed or the total is not one of
     the bundle counts, so the shopper always knows which rate the button is charging. */
  function renderRate() {
    var el = root.querySelector('[data-hh-rate]'); if (!el) return;
    var tot = totalQty(), t = tierFor(tot), multi = chosenSizes().length > 1;
    var exact = D.tiers.some(function (x) { return x.q === tot; });
    var txt = '';
    if (tot > 0 && (multi || !exact)) {
      if (t.q) txt = '<b>' + boxesTxt(tot) + '</b> &middot; ' + tierName(t) + ' price';
      else if (D.bn && D.tiers[0]) txt = '<b>' + boxesTxt(tot) + '</b> &middot; ' + tierName(D.tiers[0]) + ' price';
      else if (D.tiers[0]) txt = '<b>' + boxesTxt(tot) + '</b> &middot; add ' + (D.tiers[0].q - tot) + ' more for ' + tierName(D.tiers[0]) + ' price';
    }
    el.innerHTML = txt; el.hidden = !txt;
  }

  function renderBuy() {
    /* Black November: Set & Forget is switched off - no purchase options at all */
    if (D.bn) { root.querySelector('[data-hh-buylist]').innerHTML = ''; return; }
    var q = totalQty();
    var oneTotal = perBox(q, 'one') * q;
    var subTotal = perBox(q, 'sub', recommended ? recommended.id : null) * q;
    /* The panel now renders in one-time mode too, where state.planId is null, so fall
       back to the recommended plan for the SELECTED option or the browser would show
       the shortest cadence. Display only — planId itself stays null until the shopper
       is actually on Set & Forget, which is what keeps selling_plan off a one-time add. */
    var freqSel = state.planId || (recommended ? recommended.id : null);
    var freqOpts = payg.map(function (p) { return '<option value="' + p.id + '"' + (String(p.id) === String(freqSel) ? ' selected' : '') + '>' + cleanName(p) + '</option>'; }).join('');
    var cp = currentPlan();

    var html = '';
    if (payg.length) {
      html += '<div class="hh-t-optbox' + (state.mode === 'sub' ? ' is-on' : '') + '" data-mode="sub">' +
        '<div class="hh-t-opt"><span class="hh-t-radio"></span>' +
        '<span class="hh-t-optmain"><b>' + SUB_TITLE + '</b><span class="hh-t-pill">SAVE ' + Math.round(subPct) + '% MORE</span>' +
        (LABEL.subSub ? '<span class="hh-t-optsub">' + LABEL.subSub + '</span>' : '') + '</span>' +
        '<span class="hh-t-opttot"><s>' + money(oneTotal) + '</s>' + money(subTotal) + '</span></div>' +
        /* Panel stays rendered in BOTH modes (30 Sep 2026). It used to render only
           when mode was 'sub', so choosing One-time collapsed the benefits and the
           frequency picker out of the DOM entirely; the owner wants them readable
           either way, with only the outline saying which option is selected. */
        ('<div class="hh-t-panel"><ul class="hh-t-perks">' +
              '<li><b>No commitment</b> &mdash; skip, delay, change sizes or stop in one tap</li>' +
              '<li><b>Shipping Protection</b> &mdash; lost or damaged? Replaced, no questions</li>' +
              '<li><b>Price Lock</b> &mdash; your member rate never rises</li>' +
              '<li><b>60-Day Money Back Guarantee</b> &mdash; not the toughest gloves you’ve used? Full refund</li>' +
            '</ul><label class="hh-t-flabel">Send me more every <span class="hh-t-flabel-hint">— you choose, change any time</span></label>' +
            '<span class="hh-t-freqwrap"><select data-hh-freq>' + freqOpts + '</select></span>' +
            (q > 0 && cp ? '<div class="hh-t-renew">🔁 Renews at <b>' + money(perBox(q, state.mode) * q) + '</b> ' + everyTxt(cp) + ' &mdash; same price, every time.</div>' : '') +
            '<span class="hh-t-hint">Most tradies reorder around every 8 weeks. We’ll email you 3 days before each delivery &mdash; skip it or push it back any time.</span></div>') +
      '</div>';
    }
    html += '<div class="hh-t-optbox hh-t-optbox--slim' + (state.mode === 'one' ? ' is-on' : '') + '" data-mode="one">' +
      '<div class="hh-t-opt"><span class="hh-t-radio"></span>' +
      '<span class="hh-t-optmain"><b>One-time purchase</b></span>' +
      '<span class="hh-t-opttot">' + money(oneTotal) + '</span></div></div>';
    root.querySelector('[data-hh-buylist]').innerHTML = html;
  }

  function renderAddon() {
    var wrap = root.querySelector('[data-hh-addon]');
    if (!wrap || !D.addon || !D.addon.variants.length) { if (wrap) wrap.hidden = true; return; }
    if (totalQty() >= 10) { wrap.hidden = true; state.addon = null; return; }
    wrap.hidden = false;
    var opts = D.addon.variants.map(function (v) { return '<option value="' + v.id + '">' + v.title + '</option>'; }).join('');
    var on = !!state.addon;
    wrap.innerHTML =
      '<div class="hh-t-addon' + (on ? ' is-on' : '') + '">' +
        '<img src="' + D.addon.img + '" alt="" loading="lazy">' +
        '<span class="hh-t-adinfo"><b>Add ' + D.addon.title + '</b>' +
          '<span class="hh-t-adsub">Thin-gauge pack for the fine work &mdash; free at 10+ boxes</span></span>' +
        '<select class="hh-t-adsize" data-hh-adsize>' + opts + '</select>' +
        '<span class="hh-t-adprice">' + money(D.addon.variants[0].price) + '</span>' +
        '<button type="button" class="hh-t-adbtn" data-hh-adbtn>' + (on ? 'Added' : 'Add') + '</button>' +
      '</div>';
  }

  var sfBubble = null;
  function attachSfBubble(tries) {
    if (D.bn) return;
    var barEl = document.querySelector('.hh-pdp-bar .hhcr-bar');
    if (!barEl) {
      if ((tries || 0) < 40) setTimeout(function () { attachSfBubble((tries || 0) + 1); }, 150);
      return;
    }
    sfBubble = barEl.querySelector('.hhcr-sf');
    if (!sfBubble) {
      sfBubble = document.createElement('div');
      sfBubble.className = 'hhcr-b hhcr-d hhcr-sf';
      sfBubble.innerHTML = '<span class="hhcr-pct">+18%</span><span class="hhcr-off">OFF</span><span class="hhpb-cap">set &amp; forget</span>';
      barEl.appendChild(sfBubble);
    }
    syncSf();
  }
  function syncSf() {
    if (!sfBubble) return;
    sfBubble.classList.toggle('is-done', state.mode !== 'one');
    var pct = Math.round(subPct);
    sfBubble.querySelector('.hhcr-pct').textContent = '+' + pct + '%';
  }

  function renderCta() {
    var tot = totalQty();
    root.querySelector('[data-hh-addtxt]').innerHTML = tot > 0 ? 'Add ' + boxesTxt(tot) + ' &middot; ' + money(grandTotal()) : 'Pick a size';
    /* never disabled - with no boxes the tap scrolls to the sizes instead (nudgeSize) */
    root.querySelector('[data-hh-add]').disabled = false;
    syncSf();
    var bar = document.querySelector('[data-hh-sticky]');
    if (bar) {
      var sel = bar.querySelector('[data-hh-stickyqty]');
      if (sel) {
        var exact = D.tiers.some(function (t) { return t.q === tot; });
        sel.innerHTML = (exact ? '' : '<option value="" disabled selected>' + tot + ' box' + (tot === 1 ? '' : 'es') + '</option>') +
          D.tiers.map(function (t) { return '<option value="' + t.q + '"' + (t.q === tot ? ' selected' : '') + '>' + t.q + ' boxes</option>'; }).join('');
      }
      var slab = bar.querySelector('[data-hh-stickylabel]');
      if (slab) slab.textContent = tot > 0 ? 'Add ' + boxesTxt(tot) : 'Pick a size';
      var sprice = bar.querySelector('[data-hh-stickyprice]');
      sprice.innerHTML = tot > 0 ? money(grandTotal()) : '';
      sprice.classList.toggle('is-empty', !(tot > 0));
      bar.querySelector('[data-hh-stickybtn]').disabled = false;
    }
  }

  /* Picking a bundle keeps the sizes already chosen (25 Oct 2026). One size: the whole
     bundle goes in it. Several sizes: the same split scaled to the new count (largest
     remainder, so it always adds up). Nothing chosen yet: L. */
  function setTier(q) {
    var cur = chosenSizes();
    if (!cur.length) {
      var d = defaultVid(); if (!d) return;
      state.alloc = {}; state.alloc[d] = q; return;
    }
    if (cur.length === 1) { var only = cur[0]; state.alloc = {}; state.alloc[only] = q; return; }
    var tot = totalQty(), used = 0, out = {};
    var parts = cur.map(function (k) {
      var exact = state.alloc[k] * q / tot, whole = Math.floor(exact);
      used += whole;
      return { k: k, n: whole, r: exact - whole };
    });
    parts.sort(function (a, b) { return b.r - a.r; });
    for (var i = 0; used < q; i = (i + 1) % parts.length) { parts[i].n++; used++; }
    parts.forEach(function (p) { if (p.n > 0) out[p.k] = p.n; });
    state.alloc = out;
  }
  function setSize(vid) {
    var tot = totalQty() || D.defaultQty || 10;
    state.alloc = {}; state.alloc[String(vid)] = tot;
  }
  /* "Only need one box?" (owner, 25 Oct 2026). A quiet text button under the tiles - not a
     tile, the bundles stay the obvious choice. One tap: 1 box in the size already picked
     (else L), ONE-TIME (a box to try is not a subscription), and the +/- steppers open so
     it is plain the number can change. Hidden while exactly 1 one-time box is chosen. */
  function dominantVid() {
    var best = null, n = 0;
    Object.keys(state.alloc).forEach(function (k) { if ((state.alloc[k] || 0) > n) { n = state.alloc[k]; best = k; } });
    return best;
  }
  function renderOne() {
    var wrap = root.querySelector('[data-hh-one]');
    var btn = wrap && wrap.querySelector('[data-hh-onebtn]');
    if (!btn) return;
    var done = totalQty() === 1 && state.mode === 'one';
    wrap.hidden = done;
    if (done) return;
    var html = 'Just need one box? <u>Buy 1 box</u> &middot; ' + money(perBox(1, 'one'));
    if (btn.hhLast !== html) { btn.innerHTML = html; btn.hhLast = html; }
  }
  function pickOne() {
    var vid = dominantVid() || defaultVid();
    if (!vid) return;
    state.alloc = {}; state.alloc[vid] = 1;
    state.mode = 'one'; state.planId = null;
    mixOpen = true;
    renderAll();
    track('single_box_selected', { size: sizeTitle(vid), value: Math.round(perBox(1, 'one')) / 100, deal: D.bn ? 'black_november' : 'everyday' });
  }

  function renderAll() { renderTiers(); renderSizes(); renderBuy(); renderGiftPick(); renderAddon(); renderOne(); renderCta(); if (stickyQueue) stickyQueue(); }

  /* No boxes chosen and Add to cart tapped: take them to the sizes, shake the chips and
     say why, in one line. No alert, no dead button. */
  function nudgeSize() {
    var head = root.querySelector('[data-hh-sizehead]') || root.querySelector('[data-hh-sizes]');
    var grid = root.querySelector('[data-hh-sizes]');
    var msg = root.querySelector('[data-hh-sizemsg]');
    if (msg) msg.hidden = false;
    if (grid) { grid.classList.remove('hh-shake'); void grid.offsetWidth; grid.classList.add('hh-shake'); }
    var off = 14, hdr = document.querySelector('.section-header');
    if (hdr) { var hs = getComputedStyle(hdr); if (hs.position === 'sticky' || hs.position === 'fixed') off += hdr.offsetHeight; }
    var y = head.getBoundingClientRect().top + (window.pageYOffset || document.documentElement.scrollTop || 0) - off;
    try { window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' }); } catch (e) { window.scrollTo(0, Math.max(0, y)); }
  }

  /* ---------- Size guide: a bottom sheet with the size finder ----------
     The finder's markup and size table come from snippets/hh-size-guide.liquid (a <template>
     printed by the section). Bank card = 85.6 mm, so palm width = 85.6 mm + the overhang on
     the slider; the first size whose top width covers it is the answer. "Choose L" picks that
     size in the buy box and closes the sheet. */
  var guide = null;
  function closeGuide() {
    if (!guide) return;
    guide.classList.remove('is-open');
    document.documentElement.classList.remove('hh-sg-open');
    if (stickyQueue) stickyQueue();
    var l = root.querySelector('[data-hh-sizeguide]');
    if (l) { try { l.focus({ preventScroll: true }); } catch (e) {} }
  }
  function loadGuide() {
    var tpl = document.querySelector('template[data-hh-sgtpl]');
    var body = guide.querySelector('.hh-sg-body');
    body.innerHTML = '';
    if (tpl) body.appendChild(document.importNode(tpl.content, true));
    var data = [];
    try { data = JSON.parse(body.querySelector('[data-hh-sgfdata]').textContent); } catch (e) {}
    var inp = body.querySelector('[data-hh-sgfin]');
    if (!inp || !data.length) return;
    var CARD = 85.6, MAXW = 132;
    var palm = body.querySelector('[data-hh-sgfpalm]');
    var read = body.querySelector('[data-hh-sgfread]');
    var sizeEl = body.querySelector('[data-hh-sgfsize]');
    var feel = body.querySelector('[data-hh-sgffeel]');
    var pick = body.querySelector('[data-hh-sgpick]');
    body.querySelector('.hh-sgf-card').style.width = (CARD / MAXW * 100) + '%';
    /* start the slider in the middle of the size they already have picked */
    var cur = String(sizeTitle(dominantVid() || defaultVid()) || '').trim().toUpperCase();
    data.forEach(function (s, i) {
      if (s.t !== cur) return;
      var lo = i ? data[i - 1].max + 1 : 86, hi = s.max > 200 ? lo + 4 : s.max;
      inp.value = Math.max(0, Math.min(4.5, ((lo + hi) / 2 - CARD) / 10)).toFixed(1);
    });
    function upd() {
      var cm = parseFloat(inp.value) || 0, w = CARD + cm * 10;
      var s = data.filter(function (x) { return w <= x.max; })[0] || data[data.length - 1];
      var v = D.variants.filter(function (x) { return x.available && String(x.title).trim().toUpperCase() === s.t; })[0];
      palm.style.width = Math.min(100, w / MAXW * 100) + '%';
      read.textContent = cm.toFixed(1) + ' cm past the card · palm about ' + Math.round(w) + ' mm';
      sizeEl.textContent = s.t;
      feel.textContent = s.feel;
      pick.textContent = v ? 'Choose ' + s.t : s.t + ' is sold out';
      pick.disabled = !v;
      pick.setAttribute('data-hh-sgpick', v ? v.id : '');
    }
    inp.addEventListener('input', upd);
    upd();
  }
  function openGuide() {
    track('size_guide_opened', {});
    if (!guide) {
      guide = document.createElement('div');
      guide.className = 'hh-sg';
      guide.setAttribute('role', 'dialog');
      guide.setAttribute('aria-modal', 'true');
      guide.setAttribute('aria-label', 'Size guide');
      guide.innerHTML = '<div class="hh-sg-bd" data-hh-sgclose></div>' +
        '<div class="hh-sg-sheet"><div class="hh-sg-top"><span class="hh-sg-title">Size guide</span>' +
        '<button type="button" class="hh-sg-x" data-hh-sgclose aria-label="Close size guide">&times;</button></div>' +
        '<div class="hh-sg-body" tabindex="-1"><p class="hh-sg-load">Loading the size guide&hellip;</p></div></div>';
      document.body.appendChild(guide);
      guide.addEventListener('click', function (e) {
        if (e.target.closest('[data-hh-sgclose]')) { e.preventDefault(); closeGuide(); return; }
        var p = e.target.closest('[data-hh-sgpick]');
        var vid = p && p.getAttribute('data-hh-sgpick');
        if (!vid) return;
        mixOpen = false;
        setSize(vid); renderAll();
        track('size_selected', { size: sizeTitle(vid), mixed: false, from: 'size_guide' });
        closeGuide();
        var hd = root.querySelector('[data-hh-sizehead]');
        if (hd) { try { hd.scrollIntoView({ block: 'center' }); } catch (e2) {} }
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && guide && guide.classList.contains('is-open')) closeGuide();
      });
    }
    loadGuide();
    guide.classList.add('is-open');
    document.documentElement.classList.add('hh-sg-open');
    var gb = guide.querySelector('.hh-sg-body');
    try { gb.focus({ preventScroll: true }); } catch (e) {}
    if (stickyQueue) stickyQueue();
  }

  root.addEventListener('click', function (e) {
    if (e.target.closest('.hh-t-perklink')) return;
    var gsz = e.target.closest('[data-gsz]');
    if (gsz) { state.giftSize[gsz.getAttribute('data-gift')] = gsz.getAttribute('data-gsz'); renderGiftPick(); return; }
    if (e.target.closest('[data-hh-onebtn]')) { pickOne(); return; }
    var card = e.target.closest('[data-q]');
    if (card) {
      var cq = parseInt(card.getAttribute('data-q'), 10);
      setTier(cq); renderAll();
      track('tile_selected', { tile: tierName(tierFor(cq)), boxes: cq, deal: D.bn ? 'black_november' : 'everyday' });
      return;
    }
    if (e.target.closest('[data-hh-mix]')) { mixOpen = !mixOpen; renderSizes(); if (stickyQueue) stickyQueue(); return; }
    var sgl = e.target.closest('[data-hh-sizeguide]');
    if (sgl) { e.preventDefault(); openGuide(); return; }
    var mi = e.target.closest('.hh-t-mi');
    if (mi) {
      var v = mi.getAttribute('data-v'), d = parseInt(mi.getAttribute('data-d'), 10);
      state.alloc[v] = Math.max(0, (state.alloc[v] || 0) + d);
      renderAll();
      track('size_selected', { size: sizeTitle(v), mixed: chosenSizes().length > 1 });
      return;
    }
    var tile = e.target.closest('[data-sz]');
    if (tile && !e.target.closest('.hh-t-num')) {
      if (mixOpen) return; /* while mixing, only the steppers change sizes */
      var sid = tile.getAttribute('data-sz');
      setSize(sid); renderAll();
      track('size_selected', { size: sizeTitle(sid), mixed: false });
      return;
    }
    if (e.target.closest('[data-hh-adbtn]')) {
      if (state.addon) { state.addon = null; }
      else {
        var sel = root.querySelector('[data-hh-adsize]');
        var vv = D.addon.variants.filter(function (x) { return String(x.id) === String(sel.value); })[0] || D.addon.variants[0];
        state.addon = { id: vv.id, price: vv.price };
      }
      renderAddon(); renderCta(); return;
    }
    if (e.target.closest('[data-hh-add]')) { addToCart('main'); return; }
    var box = e.target.closest('[data-mode]');
    if (box) {
      var m = box.getAttribute('data-mode');
      if (m === state.mode) return;
      state.mode = m;
      state.planId = (m === 'sub' && recommended) ? recommended.id : null;
      renderAll();
    }
  });

  root.addEventListener('keydown', function (e) {
    var tile = e.target.closest('[data-sz]');
    if (tile && !mixOpen && e.target === tile && (e.key === 'Enter' || e.key === ' ')) {
      e.preventDefault(); setSize(tile.getAttribute('data-sz')); renderAll();
      track('size_selected', { size: sizeTitle(tile.getAttribute('data-sz')), mixed: false });
    }
  });

  root.addEventListener('change', function (e) {
    /* Choosing a delivery frequency IS choosing Set & Forget. The panel is visible in
       one-time mode now, so without this a shopper could set planId while One-time was
       selected and the add would quietly carry a selling_plan. Switch the mode with it. */
    if (e.target.matches('[data-hh-freq]')) { state.mode = 'sub'; state.planId = e.target.value; renderAll(); }
    if (e.target.matches('.hh-t-num')) {
      var nv = e.target.getAttribute('data-v');
      state.alloc[nv] = Math.max(0, parseInt(e.target.value, 10) || 0);
      renderAll();
      track('size_selected', { size: sizeTitle(nv), mixed: chosenSizes().length > 1 });
    }
    if (e.target.matches('[data-hh-adsize]') && state.addon) {
      var vv = D.addon.variants.filter(function (x) { return String(x.id) === String(e.target.value); })[0];
      if (vv) { state.addon = { id: vv.id, price: vv.price }; renderCta(); }
    }
  });

  function drawerSections() {
    var cd = document.querySelector('cart-drawer');
    if (cd && typeof cd.getSectionsToRender === 'function') {
      return cd.getSectionsToRender().map(function (s) { return s.id; });
    }
    return ['cart-drawer', 'cart-icon-bubble'];
  }

  /* Put back a selling plan if anything stripped it from a Set & Forget add (see cleanFetch).
     Only this product's own lines - the free bonus boxes are added without a plan on purpose. */
  function fixPlan(d) {
    var pid = state.planId;
    if (!pid || !d || !d.items) return d;
    var ours = {};
    D.variants.forEach(function (v) { ours[String(v.id)] = 1; });
    var bad = d.items.filter(function (it) { return ours[String(it.variant_id)] && !it.selling_plan_allocation; });
    if (!bad.length) return d;
    return bad.reduce(function (chain, it) {
      return chain.then(function () {
        return cleanFetch()(ORIGIN + '/cart/change.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
          body: JSON.stringify({ id: it.key, quantity: it.quantity, selling_plan: parseInt(pid, 10), sections: drawerSections(), sections_url: window.location.pathname })
        }).then(function (r) { return r.json(); });
      });
    }, Promise.resolve(d));
  }

  function addToCart(source) {
    source = source || 'main';
    var err = root.querySelector('[data-hh-err]'); err.hidden = true;
    var keys = chosenSizes();
    if (!keys.length) { nudgeSize(); track('atc_blocked_no_size', { source: source }); return; }
    var tot = totalQty();
    var atcValue = Math.round(grandTotal()) / 100;
    track('atc_clicked', { boxes: tot, value: atcValue, mode: state.mode, source: source, deal: D.bn ? 'black_november' : 'everyday' });
    if (source === 'sticky') track('sticky_atc_used', { boxes: tot, value: atcValue });

    var items = keys.map(function (k, i) {
      var it = { id: parseInt(k, 10), quantity: state.alloc[k] };
      if (state.planId) it.selling_plan = parseInt(state.planId, 10);
      /* everyday only - in Black November the freshener is a real $0 line the gift guard adds at 10+ */
      if (!D.bn && D.freshener && i === 0 && tot >= 6) it.properties = { '🎁 Free gift': 'Hygiene Hub air freshener' };
      return it;
    });
    if (state.addon) items.push({ id: parseInt(state.addon.id, 10), quantity: 1 });
    GIFTS.forEach(function (g) {
      if (state.mode === 'one') return;
      if (!g || !g.variants || !g.variants.length || tot < g.minQ) return;
      var vid = state.giftSize[g.key] || g.variants[0].id;
      items.push({ id: parseInt(vid, 10), quantity: 1, properties: { 'Free gift': 'First order only' } });
    });

    var btn = root.querySelector('[data-hh-add]'); btn.disabled = true;
    var txt = root.querySelector('[data-hh-addtxt]'); var was = txt.innerHTML; txt.textContent = 'Adding...';
    var cd = document.querySelector('cart-drawer');

    /* The page's own fetch: Shopify records the add and fires the AddToCart pixels itself,
       one event per line. Nothing is republished here - that would double-count.
       The free bonus boxes ('Free gift' lines) follow in a second add through the untouched
       fetch, so the pixels only ever see the boxes that were paid for - in one request they
       sent Meta, GA4 and TikTok a second, $0 AddToCart (measured 25 Oct 2026). */
    var gifts = items.filter(function (it) { return it.properties && it.properties['Free gift']; });
    var paid = items.filter(function (it) { return gifts.indexOf(it) < 0; });
    function post(f, list) {
      return f(ORIGIN + '/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
        body: JSON.stringify({ items: list, sections: drawerSections(), sections_url: window.location.pathname })
      }).then(function (r) { return r.json(); });
    }
    post(window.fetch.bind(window), paid).then(function (d) {
      if (d && d.status && d.status >= 400) throw new Error(d.description || 'cart error');
      return fixPlan(d);
    }).then(function (d) {
      if (!gifts.length) return d;
      return post(cleanFetch(), gifts).then(function (g) { return g && g.sections ? g : d; }, function () { return d; });
    }).then(function (d) {
      if (cd && typeof cd.renderContents === 'function' && d && d.sections) {
        cd.classList.remove('is-empty');
        cd.renderContents(d);
        if (typeof cd.open === 'function') cd.open();
        [250, 700, 1400].forEach(function (ms) {
          setTimeout(function () {
            var er = document.getElementById('CartDrawer-CartErrors');
            if (er) er.textContent = '';
          }, ms);
        });
      } else { window.location = '/cart'; return; }
      btn.disabled = false; txt.innerHTML = was;
    }).catch(function () {
      err.hidden = false; err.textContent = 'Could not add to cart. Please try again.';
      btn.disabled = false; txt.innerHTML = was;
    });
  }

  /* Reviews slider (owner, 26 Oct 2026): one review in the middle with a peek of the one either
     side, the next one every 5 seconds, swipe or the arrows to move. The arrows and dots copy the
     product photos' (hh-gallery.js). Two clones at each end make it loop without the peek ever
     showing a gap: after sliding onto a clone it jumps, unanimated, to the review it copies.
     It holds still while touched, hovered or focused, for 10s after someone moves it, while off
     screen or in a hidden tab, and never moves by itself for reduced-motion users. The current
     slide and dot are marked with ATTRIBUTES, not classes: hh-buybox-plus.js watches class
     changes in this box, and a class flip every 5 seconds would wake it for nothing. */
  function revSlider(wrap, start) {
    var track = wrap.querySelector('[data-hh-revtrack]');
    if (!track) return;
    var real = Array.prototype.slice.call(track.querySelectorAll('[data-hh-rev]'));
    var n = real.length, OFF = 2;
    if (n < 2) return;
    real.forEach(function (r, i) {
      r.hidden = false;
      r.setAttribute('role', 'group');
      r.setAttribute('aria-roledescription', 'slide');
      r.setAttribute('aria-label', (i + 1) + ' of ' + n);
    });
    function clone(r) {
      var k = r.cloneNode(true);
      ['data-hh-rev', 'role', 'aria-roledescription', 'aria-label'].forEach(function (a) { k.removeAttribute(a); });
      k.setAttribute('aria-hidden', 'true');
      return k;
    }
    track.insertBefore(clone(real[n - 1]), real[0]);
    track.insertBefore(clone(real[(n - 2 + n) % n]), track.firstChild);
    track.appendChild(clone(real[0]));
    track.appendChild(clone(real[1 % n]));
    var slides = track.children;
    var nav = document.createElement('div');
    nav.className = 'hh-rv-nav';
    var h = '<button type="button" class="hh-rv-arr" data-rv="-1" aria-label="Previous review">&larr;</button><span class="hh-rv-dots">';
    for (var i = 0; i < n; i++) h += '<button type="button" class="hh-rv-dot" data-rvi="' + i + '" aria-label="Review ' + (i + 1) + ' of ' + n + '"></button>';
    nav.innerHTML = h + '</span><button type="button" class="hh-rv-arr" data-rv="1" aria-label="Next review">&rarr;</button>';
    wrap.appendChild(nav);
    var dots = nav.querySelectorAll('.hh-rv-dot');
    var pos = OFF + start, hold = 0, inside = false, onScreen = true, settleT = null;
    var still = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

    function xOf(p) { var s = slides[p]; return -(s.offsetLeft - (wrap.clientWidth - s.offsetWidth) / 2); }
    function paint(p, animate) {
      track.style.transition = animate ? '' : 'none';
      track.style.transform = 'translate3d(' + xOf(p) + 'px,0,0)';
      var ri = ((p - OFF) % n + n) % n;
      Array.prototype.forEach.call(slides, function (s, k) { if (k === p) s.setAttribute('data-on', ''); else s.removeAttribute('data-on'); });
      Array.prototype.forEach.call(dots, function (d, k) { if (k === ri) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current'); });
    }
    function settle() {
      clearTimeout(settleT);
      if (pos >= OFF + n) { pos -= n; paint(pos, false); }
      else if (pos < OFF) { pos += n; paint(pos, false); }
    }
    function go(p) {
      pos = p;
      paint(pos, !still);
      clearTimeout(settleT);
      settleT = setTimeout(settle, still ? 0 : 520);
    }
    track.addEventListener('transitionend', function (e) { if (e.target === track) settle(); });
    paint(pos, false);

    nav.addEventListener('click', function (e) {
      var a = e.target.closest('[data-rv]'), d = e.target.closest('[data-rvi]');
      if (!a && !d) return;
      hold = Date.now() + 10000;
      settle();
      go(a ? pos + parseInt(a.getAttribute('data-rv'), 10) : OFF + parseInt(d.getAttribute('data-rvi'), 10));
    });

    /* swipe: a sideways drag moves it, an up-down one scrolls the page (touch-action: pan-y) */
    var x0 = null, y0 = 0, dx = 0, dragging = false, base = 0;
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      settle();
      x0 = e.clientX; y0 = e.clientY; dx = 0; dragging = false; base = xOf(pos);
    });
    track.addEventListener('pointermove', function (e) {
      if (x0 === null) return;
      dx = e.clientX - x0;
      if (!dragging) {
        if (Math.abs(dx) < 8 || Math.abs(dx) < Math.abs(e.clientY - y0)) return;
        dragging = true;
        try { track.setPointerCapture(e.pointerId); } catch (er) {}
      }
      track.style.transition = 'none';
      track.style.transform = 'translate3d(' + (base + dx) + 'px,0,0)';
    });
    function up() {
      if (x0 === null) return;
      x0 = null;
      if (!dragging) return;
      dragging = false;
      hold = Date.now() + 10000;
      go(Math.abs(dx) > 40 ? pos + (dx < 0 ? 1 : -1) : pos);
    }
    track.addEventListener('pointerup', up);
    track.addEventListener('pointercancel', up);

    wrap.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') inside = true; });
    wrap.addEventListener('pointerleave', function () { inside = false; });
    wrap.addEventListener('focusin', function () { inside = true; });
    wrap.addEventListener('focusout', function () { inside = false; });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { onScreen = en[0].isIntersecting; }).observe(wrap);
    }
    window.addEventListener('resize', function () { settle(); paint(pos, false); });
    if (!still) setInterval(function () {
      if (inside || x0 !== null || !onScreen || document.hidden || Date.now() < hold) return;
      settle();
      go(pos + 1);
    }, 5000);
  }

  function mount() {
    var info = document.querySelector('.product__info-container');
    if (info) {
      var vs = info.querySelector('variant-selects');
      var anchor = vs || info.querySelector('fieldset.product-form__input');
      if (anchor) {
        var host = anchor.closest('.product__info-container > *') || anchor;
        host.insertAdjacentElement('afterend', root);
      } else { info.appendChild(root); }
      if (vs) {
        Array.prototype.forEach.call(vs.querySelectorAll('fieldset, legend'), function (el) {
          if (!el.querySelector('.hh-size-alt')) el.style.display = 'none';
        });
      }
    }
    /* the real Judge.me reviews under the guarantee: a different one leads on each page view
       (picked before the box is shown, so nothing swaps on screen); revSlider() takes over
       once the box is visible, because it needs real widths */
    var revs = root.querySelectorAll('[data-hh-rev]');
    var revStart = 0;
    if (revs.length) {
      try { revStart = (parseInt(sessionStorage.getItem('hh_rev_i') || '-1', 10) + 1) % revs.length; sessionStorage.setItem('hh_rev_i', String(revStart)); }
      catch (e) { revStart = Math.floor(Math.random() * revs.length); }
      Array.prototype.forEach.call(revs, function (r, i) { r.hidden = i !== revStart; });
    }
    if (!document.querySelector('template[data-hh-sgtpl]')) {
      var sgLink = root.querySelector('[data-hh-sizeguide]');
      if (sgLink) sgLink.style.display = 'none';
    }
    root.hidden = false;
    document.documentElement.classList.add('hh-tiers-on');
    var revWrap = root.querySelector('[data-hh-revs]');
    if (revWrap && revs.length > 1) revSlider(revWrap, revStart);

    var bar = document.querySelector('[data-hh-sticky]');
    if (bar) {
      document.body.appendChild(bar);
      bar.addEventListener('click', function (e) { if (e.target.closest('[data-hh-stickybtn]')) addToCart('sticky'); });
      bar.addEventListener('change', function (e) {
        if (e.target.matches('[data-hh-stickyqty]') && e.target.value) { setTier(parseInt(e.target.value, 10)); renderAll(); }
      });
      /* The bar is visible whenever the REAL Add to cart is not on screen - above the
         fold or below it, it makes no difference. It hides only while the shopper can
         actually see the real button, so the two never compete. Owner call 2 Oct 2026;
         before that it only appeared after the button had scrolled off the TOP, which
         left the first screenful with no way to add.
         threshold .55 means "more than half the button showing" counts as seeing it -
         a 1px sliver at the edge of the viewport does not, so the bar does not flicker
         as the button crosses the fold. */
      /* 25 Oct 2026, second pass (owner): always on screen, from the first screen down. The
         earlier rule that hid it while the tiles or size chips sat behind it is gone - the
         owner wants the button there the whole time. It still steps aside while the real
         Add to cart is in view and while the size guide is open. */
      var cta = root.querySelector('[data-hh-add]');
      var ticking = false;
      var syncSticky = function () {
        ticking = false;
        var vh = window.innerHeight || document.documentElement.clientHeight;
        var r = cta.getBoundingClientRect();
        var seen = Math.min(r.bottom, vh) - Math.max(r.top, 0);
        var show = !(r.height && seen >= r.height * 0.55);
        if (document.documentElement.classList.contains('hh-sg-open')) show = false;
        bar.classList.toggle('is-vis', show);
      };
      stickyQueue = function () {
        if (ticking) return;
        ticking = true;
        (window.requestAnimationFrame || window.setTimeout)(syncSticky);
      };
      window.addEventListener('scroll', stickyQueue, { passive: true });
      window.addEventListener('resize', stickyQueue);
      syncSticky();
    }
    attachSfBubble(0);
    renderCta();
  }

  setTier(D.defaultQty || 10);
  renderAll();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount); else mount();
})();